import { render, staticRenderFns } from "./terms_conditions_component.vue?vue&type=template&id=3e60723e&scoped=true&"
import script from "./terms_conditions_component.vue?vue&type=script&lang=js&"
export * from "./terms_conditions_component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e60723e",
  null
  
)

export default component.exports